import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReferralsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getOriginationUrl = createAsyncThunk<
  string,
  void,
  { dispatch: ReferralsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_ORIGINATION_URL, async (_, { extra }) => {
  return await extra.referralsRepo.getOriginationUrl();
});
